// Generated by Avo VERSION 210.1.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true;
        } catch (e) {
          return false;
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self,
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj);
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]',
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return (
          obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
        );
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name');
    }
    return name.toLowerCase();
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value;
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value };
      },
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator;
      };
    }

    return iterator;
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name));
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items);
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items);
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items);
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('');
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0);
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer;
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (
        support.searchParams &&
        URLSearchParams.prototype.isPrototypeOf(body)
      ) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (
        support.arrayBuffer &&
        (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))
      ) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (
          support.searchParams &&
          URLSearchParams.prototype.isPrototypeOf(body)
        ) {
          this.headers.set(
            'content-type',
            'application/x-www-form-urlencoded;charset=UTF-8',
          );
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode);
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse);
    };

    // @ts-ignore
    return this;
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read');
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests');
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit });
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form;
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers;
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url,
    });
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response;
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code');
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } });
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (
      self as any
    ).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'));
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || ''),
        };
        (options as any).url =
          'responseURL' in xhr
            ? xhr.responseURL
            : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(
        typeof request._bodyInit === 'undefined' ? null : request._bodyInit,
      );
    });
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = 'prod',
  Dev = 'dev',
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (
    userId: string,
    userProperties: Record<string, any>,
  ) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[];
  shape?: any;
  shapeUserProps?: any;
  actualType?: string;
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = 'iC8Ieqkcb1iIucwJHKZJ';
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;

// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target: any, _varArgs: any) {
      // .length of function is 2
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true,
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = 'BottomRight',
  BottomLeft = 'BottomLeft',
  TopRight = 'TopRight',
  TopLeft = 'TopLeft',
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
};

let InternalAvoLogger: any = {
  logEventSent: function logEventSent(
    eventName: string,
    eventProperties: any,
    userProperties: any,
  ) {
    const message =
      'Event Sent:' +
      eventName +
      'Event Props:' +
      JSON.stringify(eventProperties) +
      'User Props:' +
      JSON.stringify(userProperties);

    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logDebug &&
      __AVO_LOGGER__.logDebug(__AVO_ENV__, message)
    ) {
      return;
    }
    typeof console !== 'undefined' &&
      console.log(
        '[avo] Event Sent:',
        eventName,
        'Event Props:',
        eventProperties,
        'User Props:',
        userProperties,
      );
  },

  log: function log(message: string) {
    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logDebug &&
      __AVO_LOGGER__.logDebug(__AVO_ENV__, message)
    ) {
      return;
    }
    typeof console !== 'undefined' && console.log('[avo] ' + message);
  },

  warn: function warn(message: string) {
    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logWarn &&
      __AVO_LOGGER__.logWarn(__AVO_ENV__, message)
    ) {
      return;
    }
    typeof console !== 'undefined' && console.warn('[avo] ' + message);
  },

  error: function error(message: string, error: string) {
    if (
      __AVO_LOGGER__ &&
      __AVO_LOGGER__.logError &&
      __AVO_LOGGER__.logError(__AVO_ENV__, message + error)
    ) {
      return;
    }
    typeof console !== 'undefined' && console.error('[avo] ' + message, error);
  },
};

function convertPropertiesArrayToMap(
  propertiesArray: [{ id: string; name: string; value: string }],
): { string: string | null | undefined } {
  let result: { string: string } = {};

  propertiesArray.forEach((value) => {
    result[value.name] = value.value;
  });

  return result;
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
};

AvoAssert = {
  assertObject: function assertObject(
    propertyId: string,
    propName: string,
    obj: any,
  ) {
    if (typeof obj !== 'object') {
      let message =
        propName +
        ' should be of type object but you provided type ' +
        typeof obj +
        ' with value ' +
        JSON.stringify(obj);
      return [
        {
          tag: 'expectedObjectType',
          propertyId,
          message,
          actualType: typeof obj,
        },
      ];
    } else {
      return [];
    }
  },

  assertString: function assertString(
    propertyId: string,
    propName: string,
    str: string,
  ) {
    if (typeof str !== 'string') {
      let message =
        propName +
        ' should be of type string but you provided type ' +
        typeof str +
        ' with value ' +
        JSON.stringify(str);
      return [
        {
          tag: 'expectedStringType',
          propertyId,
          message,
          actualType: typeof str,
        },
      ];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(
    propertyId: string,
    propName: string,
    int: number,
  ) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message =
        propName +
        ' should be of type int but you provided type float with value ' +
        JSON.stringify(int);
      return [
        { tag: 'expectedIntType', propertyId, message, actualType: 'float' },
      ];
    } else if (typeof int !== 'number') {
      let message =
        propName +
        ' should be of type int but you provided type ' +
        typeof int +
        ' with value ' +
        JSON.stringify(int);
      return [
        { tag: 'expectedIntType', propertyId, message, actualType: typeof int },
      ];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(
    propertyId: string,
    propName: string,
    long: number,
  ) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message =
        propName +
        ' should be of type long but you provided type float with value ' +
        JSON.stringify(long);
      return [
        { tag: 'expectedLongType', propertyId, message, actualType: 'float' },
      ];
    } else if (typeof long !== 'number') {
      let message =
        propName +
        ' should be of type long but you provided type ' +
        typeof long +
        ' with value ' +
        JSON.stringify(long);
      return [
        {
          tag: 'expectedLongType',
          propertyId,
          message,
          actualType: typeof long,
        },
      ];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(
    propertyId: string,
    propName: string,
    float: number,
  ) {
    if (typeof float !== 'number') {
      let message =
        propName +
        ' should be of type float but you provided type ' +
        typeof float +
        ' with value ' +
        JSON.stringify(float);
      return [
        {
          tag: 'expectedFloatType',
          propertyId,
          message,
          actualType: typeof float,
        },
      ];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(
    propertyId: string,
    propName: string,
    bool: boolean,
  ) {
    if (typeof bool !== 'boolean') {
      let message =
        propName +
        ' should be of type boolean but you provided type ' +
        typeof bool +
        ' with value ' +
        JSON.stringify(bool);
      return [
        {
          tag: 'expectedBoolType',
          propertyId,
          message,
          actualType: typeof bool,
        },
      ];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number,
  ) {
    if (value > max) {
      let message =
        propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{ tag: 'expectedMax', propertyId, message }];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number,
  ) {
    if (value < min) {
      let message =
        propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{ tag: 'expectedMin', propertyId, message }];
    } else {
      return [];
    }
  },

  assertList: function assertList(
    propertyId: string,
    propName: string,
    value: any,
  ) {
    if (!Array.isArray(value)) {
      let message =
        propName +
        ' should be of type list but you provided type ' +
        typeof value;
      return [{ tag: 'expectedList', propertyId, message }];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(
    eventName: string,
    input: string[],
    spec: string[],
  ) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message =
        'Additional properties when sending event ' +
        eventName +
        ': ' +
        JSON.stringify(additionalKeys);
      return [
        {
          tag: 'expectedNoAdditionalProperties',
          additionalProperties: additionalKeys,
          message: message,
        },
      ];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(
    eventName: string,
    input: string[],
    spec: string[],
  ) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message =
        'Additional user properties when sending event ' +
        eventName +
        ': ' +
        JSON.stringify(additionalKeys);
      return [
        {
          tag: 'expectedNoAdditionalUserProperties',
          additionalProperties: additionalKeys,
          message: message,
        },
      ];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(
  env: AvoEnv,
  eventId: string,
  hash: string,
  messages: { tag: string; propertyId: string }[],
  origin: string,
) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') {
    return;
  }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch('https://api.avo.app/i', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ac: 'fVc4DynfvWZJuSZRGqeq',
          br: 'nKh1-E0tYjqQaktaFGDvs',
          en: env,
          ev: eventId,
          ha: hash,
          sc: 'pUcuftd8KVtPST9UVaqE',
          se: new Date().toISOString(),
          so: 'cVLp5BuhzEbxoyCwO5k1m',
          va: messages.length === 0,
          me: messages,
          or: origin,
        }),
      })
        .then(function (res: any) {
          return res.json();
        })
        .then(function (data: any) {
          _avo_sampling_rate = data.sa;
        })
        .catch(function () {});
    }
  }
};

_avo_invoke_meta = function _avo_invoke_meta(
  env: AvoEnv,
  type: string,
  messages: { tag: string; propertyId: string }[],
  origin: string,
) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') {
    return;
  }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch('https://api.avo.app/i', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ac: 'fVc4DynfvWZJuSZRGqeq',
          br: 'nKh1-E0tYjqQaktaFGDvs',
          en: env,
          ty: type,
          sc: 'pUcuftd8KVtPST9UVaqE',
          se: new Date().toISOString(),
          so: 'cVLp5BuhzEbxoyCwO5k1m',
          va: messages.length === 0,
          me: messages,
          or: origin,
        }),
      })
        .then(function (res: any) {
          return res.json();
        })
        .then(function (data: any) {
          _avo_sampling_rate = data.sa;
        })
        .catch(function () {});
    }
  }
};

let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://www.avo.app') {
      return;
    }
    let iframe: any = document.getElementById('avo-debugger');
    if (
      iframe &&
      event &&
      event.data &&
      event.data.type_ === 'avo-debugger-update-style'
    ) {
      iframe.style = event.data.style;
    } else if (
      iframe &&
      event &&
      event.data &&
      event.data.type_ === 'avo-debugger-ready'
    ) {
      let message = {
        type_: 'avo-debugger-boot-events',
        schemaId: 'pUcuftd8KVtPST9UVaqE',
        href: window.location.href,
        events: _avo_debugger_events_during_boot,
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(
        message,
        'https://www.avo.app/_debugger',
      );
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(
  eventId: string,
  eventName: string,
  messages: any[],
  eventProperties: any[],
  userProperties: any[],
  groupProperties: any[],
) {
  if (typeof (window as any) === 'undefined') {
    return;
  }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties,
  };

  if (_avo_debugger_ready) {
    let message = { type_: 'avo-debugger-events', events: [event] };
    (document.getElementById('avo-debugger') as any).contentWindow.postMessage(
      message,
      'https://www.avo.app/_debugger',
    );
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
};

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') {
    return;
  }
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://www.avo.app') {
      return;
    }
    if (event.data.type_ === 'avo-debugger-ready' && position !== null) {
      var message = { type_: 'avo-debugger-position', position: position };
      document
        .getElementById('avo-debugger')
        .contentWindow.postMessage(message, 'https://www.avo.app/_debugger');
    }
  });
}

export const LearningCenterRelatedArticlePosition = {
  CENTERED_CLICKED: 'centered_clicked',
  LEFT_CLICKED: 'left_clicked',
  RIGHT_CLICKED: 'right_clicked',
} as const;
export type LearningCenterRelatedArticlePositionType =
  typeof LearningCenterRelatedArticlePosition;
export type LearningCenterRelatedArticlePositionValueType =
  LearningCenterRelatedArticlePositionType[keyof LearningCenterRelatedArticlePositionType];

export const RocketCompany = {
  MORTGAGE: 'mortgage',
  MORTGAGE_US: 'mortgage:us',
  MORTGAGE_CA: 'mortgage:ca',
  HOMES: 'homes',
  LOANS: 'loans',
  MONEY: 'money',
  CLOSE: 'close',
} as const;
export type RocketCompanyType = typeof RocketCompany;
export type RocketCompanyValueType = RocketCompanyType[keyof RocketCompanyType];

export const InterestRateType = {
  FLOAT_RATE: 'float_rate',
  LOCK_RATE: 'lock_rate',
} as const;
export type InterestRateTypeType = typeof InterestRateType;
export type InterestRateTypeValueType =
  InterestRateTypeType[keyof InterestRateTypeType];

export const FunnelExperience = {
  ACCOUNT_WELCOME: 'account_welcome',
  ASSIST: 'assist',
  ASSIST_LAUNCHPAD: 'assist:launchpad',
  ASSIST_MORTGAGE_UNAUTH: 'assist:mortgage_unauth',
  ASSIST_MORTGAGE_UNAUTH_FLOATING_BUTTON:
    'assist:mortgage_unauth:floating_button',
  ASSIST_MORTGAGE_UNAUTH_NAV_BAR: 'assist:mortgage_unauth:nav_bar',
  ASSIST_SERVICING: 'assist:servicing',
  ASSIST_SERVICING_BUTTON: 'assist:servicing:button',
  ASSIST_SERVICING_FREE_FORM: 'assist:servicing:free_form',
  BANANA_PHONE: 'banana_phone',
  BANANA_PHONE_MOBILE_APP: 'banana_phone:mobile_app',
  BANANA_PHONE_WEB: 'banana_phone:web',
  DASHBOARD: 'dashboard',
  LAUNCHPAD: 'launchpad',
  RMA: 'rma',
  RMA_PURCHASE: 'rma:purchase',
  RMA_REFINANCE: 'rma:refinance',
  RMO: 'rmo',
  RMS: 'rms',
  STOREFRONTS: 'storefronts',
  STOREFRONTS_CALCULATOR: 'storefronts:calculator',
  STOREFRONTS_HOME_LOANS: 'storefronts:home_loans',
  STOREFRONTS_HOMES: 'storefronts:homes',
  WELCOME_TOUR: 'welcome_tour',
  RMO_SCHWAB: 'rmo:schwab',
  ROCKET_LOGIC_XP: 'rocket_logic:xp',
  ROCKET_LOGIC_PRODUCT_AND_PRICING: 'rocket_logic:product_and_pricing',
  PRO: 'pro',
  PRO_START_NEW_LOAN: 'pro:start_new_loan',
  PRO_STOREFRONT: 'pro:storefront',
  RMO_PRO: 'rmo:pro',
  LEARNING_CENTER: 'learning_center',
  STOREFRONTS_RATES: 'storefronts:rates',
  ROCKET_LOGIC_AQ: 'rocket_logic:aq',
  ROCKET_LOGIC_CQ: 'rocket_logic:cq',
  ROCKET_LOGIC_IQ: 'rocket_logic:iq',
  ROCKET_LOGIC_PQ: 'rocket_logic:pq',
  ACCOUNT_ADMIN_PROD: 'account_admin:prod',
  OUR_HOUSE: 'our_house',
  PRO_PIPELINE: 'pro:pipeline',
  NAVIGATOR: 'navigator',
  PLP_FUEL_REWARDS: 'plp:fuel_rewards',
  PLP_RELO: 'plp:relo',
  PLP_VIP: 'plp:vip',
  PLP_WELCOME: 'plp:welcome',
  RMA_LAUNCHPAD: 'rma:launchpad',
  PRO_BROKER_NEAR_ME: 'pro:broker_near_me',
  PLP_FINANCIAL_INSTITUTION: 'plp:financial_institution',
  PLP_HOME_LOAN_BENEFITS_PROGRAM: 'plp:home_loan_benefits_program',
  CLEARSIGN: 'clearsign',
} as const;
export type FunnelExperienceType = typeof FunnelExperience;
export type FunnelExperienceValueType =
  FunnelExperienceType[keyof FunnelExperienceType];

export const ButtonType = {
  ADD_COMPARISON: 'add_comparison',
  CLOSE: 'close',
  EXPLORE_HOMES_SPACES: 'explore_homes_spaces',
  HOMES_RESET_FILTERS: 'homes_reset_filters',
  HOMES_SAVE_SEARCH: 'homes_save_search',
  HOMES_SCHEDULE_TOUR: 'homes_schedule_tour',
  HOMES_SEARCH_FILTER: 'homes_search_filter',
  MARKET_REPORT: 'market_report',
  MEATBALL: 'meatball',
  SEARCH: 'search',
  SIGN_IN: 'sign_in',
  EDIT: 'edit',
  NEXT: 'next',
  BACK: 'back',
  AGREE: 'agree',
  COMPLETE: 'complete',
  EXPAND: 'expand',
  COLLAPSE: 'collapse',
  DOWNLOAD: 'download',
  VIEW: 'view',
  OTHER: 'other',
  CONTINUE: 'continue',
  SUBMIT: 'submit',
  PRESIGN_CLOSING_DOCUMENTS: 'presign_closing_documents',
  CREATE_ACCOUNT: 'create_account',
  REQUEST_CALL: 'request_call',
  COPY: 'copy',
  LOGIC_ADD_LIEN: 'logic:add_lien',
  LOGIC_ADD_PROPERTY: 'logic:add_property',
  LOGIC_ASSISTANT: 'logic:assistant',
  LOGIC_CREDIT_MANAGER: 'logic:credit_manager',
  LOGIC_DELETE_LIEN: 'logic:delete_lien',
  LOGIC_DELETE_PROPERTY: 'logic:delete_property',
  LOGIC_REASSOCIATE_LIEN: 'logic:reassociate_lien',
  LOGIC_SEARCH: 'logic:search',
  LOGIC_SERVICED_LOAN_DATA: 'logic:serviced_loan_data',
  LOGIC_SUPPORT: 'logic:support',
  SAVE: 'save',
  UPLOAD: 'upload',
  ADD: 'add',
  LINK_TO_URL: 'link_to_url',
  LOGIC_ACTIONS: 'logic:actions',
  LOGIC_ASSETS: 'logic:assets',
  LOGIC_BANKING: 'logic:banking',
  LOGIC_CLIENT_INFO: 'logic:client_info',
  LOGIC_CREDIT: 'logic:credit',
  LOGIC_DASHBOARD: 'logic:dashboard',
  LOGIC_EMPLOYERS: 'logic:employers',
  LOGIC_FINDINGS: 'logic:findings',
  LOGIC_HOME: 'logic:home',
  LOGIC_INCOME: 'logic:income',
  LOGIC_PRODUCTS: 'logic:products',
  LOGIC_PROPERTY: 'logic:property',
  LOGIC_QFRS: 'logic:qfrs',
  LOGIC_SETTINGS: 'logic:settings',
  LOGIC_UNDERWRITING: 'logic:underwriting',
  NAV: 'nav',
  REFRESH: 'refresh',
  HOMES_FAVORITE: 'homes_favorite',
  HOMES_MAP_SAVE: 'homes_map_save',
  PAGINATION: 'pagination',
  HOMES_ADD_TRAVEL_TIME: 'homes_add_travel_time',
  LAUNCH: 'launch',
  REQUEST_CHAT: 'request_chat',
  CALCULATE: 'calculate',
  DELETE: 'delete',
  RESET: 'reset',
  RESTORE: 'restore',
  CLEAR_QUEUE: 'clear_queue',
  CREATE_GROUP_CALL: 'create_group_call',
  DIAL_PAD: 'dial_pad',
  DIAL_PHONE_NUMBER: 'dial_phone_number',
  HOLD: 'hold',
  MUTE: 'mute',
  NOT_READY_FOR_CALLS: 'not_ready_for_calls',
  OUR_HOUSE_DASHBOARD: 'our_house_dashboard',
  READY_FOR_CALLS: 'ready_for_calls',
  SEND_TEXT: 'send_text',
  START_PIPELINE: 'start_pipeline',
  START_UNALLOCATED: 'start_unallocated',
  STOP_PIPELINE: 'stop_pipeline',
  STOP_UNALLOCATED: 'stop_unallocated',
  HIDE: 'hide',
  SHOW: 'show',
  SIGN_OUT: 'sign_out',
  FILTER: 'filter',
  LOGIC_ROCKETED_LOAN: 'logic:rocketed_loan',
  COOKIE_CONSENT: 'cookie_consent',
} as const;
export type ButtonTypeType = typeof ButtonType;
export type ButtonTypeValueType = ButtonTypeType[keyof ButtonTypeType];

export const LinkType = {
  HOMES_BACK_TO_ALL_LISTINGS: 'homes_back_to_all_listings',
  HOMES_CLEAR_LOCATION: 'homes_clear_location',
  HOMES_TO_NEXT_LISTING: 'homes_to_next_listing',
  ANCHOR: 'anchor',
  COLLAPSE: 'collapse',
  EXPAND: 'expand',
  INBOUND_CALL_NUMBER: 'inbound_call_number',
  NAV: 'nav',
  VIEW_DOCUMENT: 'view_document',
  SORT_ALPHABETICALLY: 'sort_alphabetically',
  SORT_BY_BIGGEST: 'sort_by_biggest',
  SORT_BY_NO: 'sort_by_no',
  SORT_BY_SMALLEST: 'sort_by_smallest',
  SORT_BY_YES: 'sort_by_yes',
  SORT_REVERSE_ALPHABETICALLY: 'sort_reverse_alphabetically',
  ADMIN_ACTION: 'admin_action',
  BACK: 'back',
  CREATE_ACCOUNT: 'create_account',
  OTHER: 'other',
  RESET_PASSWORD: 'reset_password',
  SIGN_IN: 'sign_in',
  VIEW_OPTIONS: 'view_options',
  CLIENT_PHONE_NUMBER: 'client_phone_number',
  REQUEST_CALL: 'request_call',
  REQUEST_CHAT: 'request_chat',
  EDIT: 'edit',
  SORT_BY_NEWEST: 'sort_by_newest',
  SORT_BY_OLDEST: 'sort_by_oldest',
} as const;
export type LinkTypeType = typeof LinkType;
export type LinkTypeValueType = LinkTypeType[keyof LinkTypeType];

let sysAppVersion: any;
let sysDeviceType: any;
let sysOsVersion: any;
let sysBrowserVersion: any;
let sysSystemRocketAccountId: any;
let sysSystemRvid: any;
let sysSystemRocketMortgageClientId: any;
let sysSystemClientId: any;
let sysSystemGcid: any;
let sysSystemCommonId: any;
let sysSystemRockHumanId: any;
let sysSystemSessionReplayId: any;
let sysSystemEventId: any;
let sysSystemCooperCustomerId: any;

export function setSystemProperties(properties: {
  appVersion: string;
  deviceType: string | null | undefined;
  osVersion: string | null | undefined;
  browserVersion: string;
  systemRocketAccountId: string;
  systemRvid: string;
  systemRocketMortgageClientId: string;
  systemClientId: string;
  systemGcid: string;
  systemCommonId: string;
  systemRockHumanId: string;
  systemSessionReplayId: string;
  systemEventId: string;
  systemCooperCustomerId: string | null | undefined;
}) {
  if (properties.appVersion !== null && properties.appVersion !== undefined) {
    sysAppVersion = properties.appVersion;
  }
  if (properties.deviceType !== null && properties.deviceType !== undefined) {
    sysDeviceType = properties.deviceType;
  }
  if (properties.osVersion !== null && properties.osVersion !== undefined) {
    sysOsVersion = properties.osVersion;
  }
  if (
    properties.browserVersion !== null &&
    properties.browserVersion !== undefined
  ) {
    sysBrowserVersion = properties.browserVersion;
  }
  if (
    properties.systemRocketAccountId !== null &&
    properties.systemRocketAccountId !== undefined
  ) {
    sysSystemRocketAccountId = properties.systemRocketAccountId;
  }
  if (properties.systemRvid !== null && properties.systemRvid !== undefined) {
    sysSystemRvid = properties.systemRvid;
  }
  if (
    properties.systemRocketMortgageClientId !== null &&
    properties.systemRocketMortgageClientId !== undefined
  ) {
    sysSystemRocketMortgageClientId = properties.systemRocketMortgageClientId;
  }
  if (
    properties.systemClientId !== null &&
    properties.systemClientId !== undefined
  ) {
    sysSystemClientId = properties.systemClientId;
  }
  if (properties.systemGcid !== null && properties.systemGcid !== undefined) {
    sysSystemGcid = properties.systemGcid;
  }
  if (
    properties.systemCommonId !== null &&
    properties.systemCommonId !== undefined
  ) {
    sysSystemCommonId = properties.systemCommonId;
  }
  if (
    properties.systemRockHumanId !== null &&
    properties.systemRockHumanId !== undefined
  ) {
    sysSystemRockHumanId = properties.systemRockHumanId;
  }
  if (
    properties.systemSessionReplayId !== null &&
    properties.systemSessionReplayId !== undefined
  ) {
    sysSystemSessionReplayId = properties.systemSessionReplayId;
  }
  if (
    properties.systemEventId !== null &&
    properties.systemEventId !== undefined
  ) {
    sysSystemEventId = properties.systemEventId;
  }
  if (
    properties.systemCooperCustomerId !== null &&
    properties.systemCooperCustomerId !== undefined
  ) {
    sysSystemCooperCustomerId = properties.systemCooperCustomerId;
  }
}

let Segment: any;

export function initAvo(
  options: {
    env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger;
  },
  systemProperties: {
    appVersion: string;
    deviceType: string | null | undefined;
    osVersion: string | null | undefined;
    browserVersion: string;
    systemRocketAccountId: string;
    systemRvid: string;
    systemRocketMortgageClientId: string;
    systemClientId: string;
    systemGcid: string;
    systemCommonId: string;
    systemRockHumanId: string;
    systemSessionReplayId: string;
    systemEventId: string;
    systemCooperCustomerId: string | null | undefined;
  },
  destinationOptions: any,
  SegmentDestination: CustomDestination,
) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn(
      '[avo] ****************************************************',
    );
    InternalAvoLogger.warn(
      '[avo] WARNING Avo cannot be initialized in noop mode in production:',
    );
    InternalAvoLogger.warn(
      '[avo] - Overwriting configuration with noop=false.',
    );
    InternalAvoLogger.warn(
      '[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true',
    );
    InternalAvoLogger.warn(
      '[avo] ****************************************************',
    );
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log(
      '[avo] ****************************************************',
    );
    InternalAvoLogger.log(
      '[avo] Avo is now initialized in noop mode. This means:',
    );
    InternalAvoLogger.log('[avo] - No events will be sent');
    InternalAvoLogger.log('[avo] - No network requests are made');
    InternalAvoLogger.log(
      '[avo] ****************************************************',
    );
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ =
    !__AVO_NOOP__ &&
    ((typeof window !== 'undefined' &&
      (window as any).location.search.indexOf('avo_debug=1') > -1) ||
      (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn(
      '[avo] Avo Inspector not provided in initAvo() call',
    );
  }

  setSystemProperties(systemProperties);

  destinationOptions = destinationOptions || {};

  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position);
    }

    (function () {
      if (typeof (window as any) === 'undefined') {
        return;
      }
      let init = function () {
        let iframe: any = document.createElement('iframe');
        document.body.appendChild(iframe);
        iframe.id = 'avo-debugger';
        iframe.src = 'https://www.avo.app/_debugger';
        iframe.style = 'display: none;';
      };

      if (document.body) {
        init();
      } else {
        document.addEventListener('DOMContentLoaded', init);
      }
    })();
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }

    Segment = SegmentDestination;
    if (__AVO_ENV__ === 'prod') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    } else if (__AVO_ENV__ === 'dev') {
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    } else {
      console[__REPORT_FAILURE_AS__ || 'error'](
        '[avo] No staging key is set for Segment. Head to destination settings in Avo to set a staging key.',
      );
      Segment && Segment.make && Segment.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface ClickedButtonProperties {
  userId_: string;
  buttonName: string;
  buttonId: string;
  buttonType: ButtonTypeValueType;
  time: string;
  experimentId: string | null | undefined;
  mortgageEstPurchasePrice: number;
  pageName: string | null | undefined;
  leadTypeCode: string | null | undefined;
}
/**
 * clicked_button: This event triggers when a user clicks a button within an application/site.
 *
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.buttonName: The descriptive name of the button that was clicked, helping to identify its function or location in the app.
 * @param properties.buttonId: The unique identifier assigned to the button that was clicked within the app.
 * @param properties.buttonType: During a clicked button event, set this to the type of button being clicked.
 * @param properties.time: Set this to the timestamp of when a user (or Rocket team member) completes the action associated with each event.
 * Amplitude compares dates as strings, using the ISO 8601 format: YYYY-MM-DDTHH:mm:ss
 * @param properties.experimentId: The combination of experiment ID and variant/control-ID of the experiment that the user experienced.
 * @param properties.mortgageEstPurchasePrice: Set this to full integer value initially entered within Rocket Mortgage for the property purchase price, including both cash (down payment, etc.) and mortgage. At this point of the journey, we consider this an estimated value.
 * @param properties.pageName: The name of the page where a particular action or event took place
 * @param properties.leadTypeCode: Set to the alphanumeric lead type code value. The lead type code identifies the type of the lead based on specific characteristics of the lead.
 *
 * @see {@link https://www.avo.app/schemas/pUcuftd8KVtPST9UVaqE/branches/nKh1-E0tYjqQaktaFGDvs/events/iANfNaGmG}
 */
export function clickedButton(properties: ClickedButtonProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'r8VuMQxqGY',
    name: 'button_name',
    value: properties.buttonName,
  });
  eventPropertiesArray.push({
    id: '6TuCCOVk8y',
    name: 'button_id',
    value: properties.buttonId,
  });
  eventPropertiesArray.push({
    id: 'xpLHL9Nnk',
    name: 'button_type',
    value: properties.buttonType,
  });
  eventPropertiesArray.push({
    id: 'O2iTlkPbDS',
    name: 'time',
    value: properties.time,
  });
  properties.experimentId !== undefined && properties.experimentId !== null
    ? eventPropertiesArray.push({
        id: '6MDW7LlnGH',
        name: 'experiment_id',
        value: properties.experimentId,
      })
    : eventPropertiesArray.push({
        id: '6MDW7LlnGH',
        name: 'experiment_id',
        value: null,
      });
  properties.pageName !== undefined && properties.pageName !== null
    ? eventPropertiesArray.push({
        id: 'YekhRhN_M1',
        name: 'page_name',
        value: properties.pageName,
      })
    : eventPropertiesArray.push({
        id: 'YekhRhN_M1',
        name: 'page_name',
        value: null,
      });
  properties.leadTypeCode !== undefined && properties.leadTypeCode !== null
    ? eventPropertiesArray.push({
        id: 'X34zATaWxvwS-TBvSHZfR',
        name: 'lead_type_code',
        value: properties.leadTypeCode,
      })
    : eventPropertiesArray.push({
        id: 'X34zATaWxvwS-TBvSHZfR',
        name: 'lead_type_code',
        value: null,
      });
  eventPropertiesArray.push({
    id: 'PbS4IP_ap1',
    name: 'app_version',
    value: sysAppVersion,
  });
  eventPropertiesArray.push({
    id: 'DNqrhbpgSj',
    name: 'device_type',
    value: sysDeviceType,
  });
  eventPropertiesArray.push({
    id: 'Ra5Oyin4Tv',
    name: 'os_version',
    value: sysOsVersion,
  });
  eventPropertiesArray.push({
    id: 'z9D75o_NW2',
    name: 'browser_version',
    value: sysBrowserVersion,
  });
  eventPropertiesArray.push({
    id: 'HVyMUTwlFin2UALtdI6AQ',
    name: 'system_rocket_account_id',
    value: sysSystemRocketAccountId,
  });
  eventPropertiesArray.push({
    id: '0mP7RIpF5jqiys6y4VlAq',
    name: 'system_rvid',
    value: sysSystemRvid,
  });
  eventPropertiesArray.push({
    id: 'FHbqjQStMeHS7fgYo5DHJ',
    name: 'system_rocket_mortgage_client_id',
    value: sysSystemRocketMortgageClientId,
  });
  eventPropertiesArray.push({
    id: 'Kk4mMVrkXLj4XzgzCWpQy',
    name: 'system_client_id',
    value: sysSystemClientId,
  });
  eventPropertiesArray.push({
    id: 'AEbCx35uG52zkAssLX_bs',
    name: 'system_gcid',
    value: sysSystemGcid,
  });
  eventPropertiesArray.push({
    id: 'mnnnJ3KJZDDauAWcFOHFR',
    name: 'system_common_id',
    value: sysSystemCommonId,
  });
  eventPropertiesArray.push({
    id: 'Hhq32LlY0mY4OwATaYwch',
    name: 'system_rock_human_id',
    value: sysSystemRockHumanId,
  });
  eventPropertiesArray.push({
    id: '--SybwLChclxCttnpge_u',
    name: 'system_session_replay_id',
    value: sysSystemSessionReplayId,
  });
  eventPropertiesArray.push({
    id: 'xUDhKmtARrXfsslyfeuAW',
    name: 'system_event_id',
    value: sysSystemEventId,
  });
  eventPropertiesArray.push({
    id: 'BOVxTE7k0qTMBeIVDxdd9',
    name: 'system_cooper_customer_id',
    value: sysSystemCooperCustomerId,
  });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  userPropertiesArray.push({
    id: 'oaNAWxZ4-1',
    name: 'mortgage_est_purchase_price',
    value: properties.mortgageEstPurchasePrice,
  });
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'iANfNaGmG',
        'f4bcb978c14e2d94c025d548e916917c3c7a76d29fbae5278d2ee830b88e4efd',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'clicked_button',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'iANfNaGmG',
        'clicked_button',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'clicked_button',
        eventProperties,
        'iANfNaGmG',
        'f4bcb978c14e2d94c025d548e916917c3c7a76d29fbae5278d2ee830b88e4efd',
      );
    }
    // destination Segment
    Segment.setUserProperties(
      properties.userId_,
      (Object as any).assign({}, userProperties),
    );
    Segment.logEvent(
      'clicked_button',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface ClickedButtonClearSignProperties {
  userId_: string;
  buttonName: string;
  buttonId: string;
  buttonType: ButtonTypeValueType;
  time: string;
  experimentId: string | null | undefined;
  mortgageEstPurchasePrice: number;
  pageName: string | null | undefined;
  leadTypeCode: string | null | undefined;
}
/**
 * clicked_button: This event triggers when a user clicks a button within an application/site., event variant
 *
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.buttonName: The descriptive name of the button that was clicked, helping to identify its function or location in the app.
 * @param properties.buttonId: The unique identifier assigned to the button that was clicked within the app.
 * @param properties.buttonType: During a clicked button event, set this to the type of button being clicked.
 * @param properties.time: Set this to the timestamp of when a user (or Rocket team member) completes the action associated with each event.
 * Amplitude compares dates as strings, using the ISO 8601 format: YYYY-MM-DDTHH:mm:ss
 * @param properties.experimentId: The combination of experiment ID and variant/control-ID of the experiment that the user experienced.
 * @param properties.mortgageEstPurchasePrice: Set this to full integer value initially entered within Rocket Mortgage for the property purchase price, including both cash (down payment, etc.) and mortgage. At this point of the journey, we consider this an estimated value.
 * @param properties.pageName: The name of the page where a particular action or event took place
 * @param properties.leadTypeCode: Set to the alphanumeric lead type code value. The lead type code identifies the type of the lead based on specific characteristics of the lead.
 *
 * @see {@link https://www.avo.app/schemas/pUcuftd8KVtPST9UVaqE/branches/nKh1-E0tYjqQaktaFGDvs/events/iANfNaGmG.OfyVM66EamBhEuyW7gpZ4}
 */
export function clickedButtonClearSign(
  properties: ClickedButtonClearSignProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'r8VuMQxqGY',
    name: 'button_name',
    value: properties.buttonName,
  });
  eventPropertiesArray.push({
    id: '6TuCCOVk8y',
    name: 'button_id',
    value: properties.buttonId,
  });
  eventPropertiesArray.push({
    id: 'xpLHL9Nnk',
    name: 'button_type',
    value: properties.buttonType,
  });
  eventPropertiesArray.push({
    id: 'O2iTlkPbDS',
    name: 'time',
    value: properties.time,
  });
  properties.experimentId !== undefined && properties.experimentId !== null
    ? eventPropertiesArray.push({
        id: '6MDW7LlnGH',
        name: 'experiment_id',
        value: properties.experimentId,
      })
    : eventPropertiesArray.push({
        id: '6MDW7LlnGH',
        name: 'experiment_id',
        value: null,
      });
  properties.pageName !== undefined && properties.pageName !== null
    ? eventPropertiesArray.push({
        id: 'YekhRhN_M1',
        name: 'page_name',
        value: properties.pageName,
      })
    : eventPropertiesArray.push({
        id: 'YekhRhN_M1',
        name: 'page_name',
        value: null,
      });
  properties.leadTypeCode !== undefined && properties.leadTypeCode !== null
    ? eventPropertiesArray.push({
        id: 'X34zATaWxvwS-TBvSHZfR',
        name: 'lead_type_code',
        value: properties.leadTypeCode,
      })
    : eventPropertiesArray.push({
        id: 'X34zATaWxvwS-TBvSHZfR',
        name: 'lead_type_code',
        value: null,
      });
  eventPropertiesArray.push({
    id: 'PbS4IP_ap1',
    name: 'app_version',
    value: sysAppVersion,
  });
  eventPropertiesArray.push({
    id: 'DNqrhbpgSj',
    name: 'device_type',
    value: sysDeviceType,
  });
  eventPropertiesArray.push({
    id: 'Ra5Oyin4Tv',
    name: 'os_version',
    value: sysOsVersion,
  });
  eventPropertiesArray.push({
    id: 'z9D75o_NW2',
    name: 'browser_version',
    value: sysBrowserVersion,
  });
  eventPropertiesArray.push({
    id: 'HVyMUTwlFin2UALtdI6AQ',
    name: 'system_rocket_account_id',
    value: sysSystemRocketAccountId,
  });
  eventPropertiesArray.push({
    id: '0mP7RIpF5jqiys6y4VlAq',
    name: 'system_rvid',
    value: sysSystemRvid,
  });
  eventPropertiesArray.push({
    id: 'FHbqjQStMeHS7fgYo5DHJ',
    name: 'system_rocket_mortgage_client_id',
    value: sysSystemRocketMortgageClientId,
  });
  eventPropertiesArray.push({
    id: 'Kk4mMVrkXLj4XzgzCWpQy',
    name: 'system_client_id',
    value: sysSystemClientId,
  });
  eventPropertiesArray.push({
    id: 'AEbCx35uG52zkAssLX_bs',
    name: 'system_gcid',
    value: sysSystemGcid,
  });
  eventPropertiesArray.push({
    id: 'mnnnJ3KJZDDauAWcFOHFR',
    name: 'system_common_id',
    value: sysSystemCommonId,
  });
  eventPropertiesArray.push({
    id: 'Hhq32LlY0mY4OwATaYwch',
    name: 'system_rock_human_id',
    value: sysSystemRockHumanId,
  });
  eventPropertiesArray.push({
    id: '--SybwLChclxCttnpge_u',
    name: 'system_session_replay_id',
    value: sysSystemSessionReplayId,
  });
  eventPropertiesArray.push({
    id: 'xUDhKmtARrXfsslyfeuAW',
    name: 'system_event_id',
    value: sysSystemEventId,
  });
  eventPropertiesArray.push({
    id: 'BOVxTE7k0qTMBeIVDxdd9',
    name: 'system_cooper_customer_id',
    value: sysSystemCooperCustomerId,
  });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  userPropertiesArray.push({
    id: 'oaNAWxZ4-1',
    name: 'mortgage_est_purchase_price',
    value: properties.mortgageEstPurchasePrice,
  });
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'iANfNaGmG.OfyVM66EamBhEuyW7gpZ4',
        '699fb001d6e9732b918ec8c479bf262c8dfd524396808fab1ecb897cad01574e',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'clicked_button',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'iANfNaGmG.OfyVM66EamBhEuyW7gpZ4',
        'clicked_button',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'clicked_button',
        eventProperties,
        'iANfNaGmG.OfyVM66EamBhEuyW7gpZ4',
        '699fb001d6e9732b918ec8c479bf262c8dfd524396808fab1ecb897cad01574e',
      );
    }
    // destination Segment
    Segment.setUserProperties(
      properties.userId_,
      (Object as any).assign({}, userProperties),
    );
    Segment.logEvent(
      'clicked_button',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface LoadedPageProperties {
  userId_: string;
  customDestinationPageName_: string;
  experimentSource: string | null | undefined;
  rocketCompany: RocketCompanyValueType;
  funnelExperience: FunnelExperienceValueType;
  qlsCode: string | null | undefined;
  interestRateFinal: number | null | undefined;
  interestRateSuggested: number | null | undefined;
  interestRateRecommended: number | null | undefined;
  amplitudeSessionReplayId: string | null | undefined;
  experimentId: string | null | undefined;
  pageName: string;
  userRvid: string | null | undefined;
  leadTypeCode: string | null | undefined;
}
/**
 * loaded_page: Trigger this event when a page loads
 *
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.experimentSource: This describes where in the product experience the experiment lives. For example, launchpad, rma, etc.
 * @param properties.rocketCompany: Set this to the Rocket company a user is interacting with through a digital or non-digital experience.
 * @param properties.funnelExperience: This is the workflow or experience a user is in within the Rocket ecosystem. Examples: launchpad, rma, etc.
 * @param properties.qlsCode: QLS is rocket's UTM equivalent, QLS code is a unique ID , which links to the entire campaign metadata set at Rocket, containing details down to the image and copy version used in the ad responsible for the traffic
 * @param properties.interestRateFinal: Set this to the closest two-point decimal value for the final interest rate a user receives when their loan closes. This interest rate should not be sent until the loan closes as that is when we know the actual final loan interest rate.
 * @param properties.interestRateSuggested: Set this to the closest two-point decimal value for the suggested interest rate a user sees in a digital top-of-funnel experience OR hears as a current interest rate from a banker on a call. This is the interest rate that initial calculations are based off of, but one that is not based on any unique known facts about the user such as credit score. It is also not a locked interest rate or a final loan interest rate.
 * @param properties.interestRateRecommended: Set this to the closest two-point decimal value for the recommended interest rate a user sees in a digital top-of-funnel experience OR hears as a current interest rate from a banker on a call AFTER providing enough personal information that we can give customized rate information factoring in their credit score. This interest rate is more specific to the user than anything in our very top-of-funnel experiences, but it is not not a locked interest rate or a final loan interest rate.
 * @param properties.amplitudeSessionReplayId: Amplitude Session Replay ID, used within Session Replay Implementation. Mapped to '[Amplitude] Session Replay ID' downstream in Segment.
 * @param properties.experimentId: The combination of experiment ID and variant/control-ID of the experiment that the user experienced.
 * @param properties.pageName: The name of the page where a particular action or event took place
 * @param properties.userRvid: Set this to the first party Rocket cookie ID.
 * @param properties.leadTypeCode: Set to the alphanumeric lead type code value. The lead type code identifies the type of the lead based on specific characteristics of the lead.
 *
 * @see {@link https://www.avo.app/schemas/pUcuftd8KVtPST9UVaqE/branches/nKh1-E0tYjqQaktaFGDvs/events/VzcK2p-7gj}
 */
export function loadedPage(properties: LoadedPageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.experimentSource !== undefined &&
  properties.experimentSource !== null
    ? eventPropertiesArray.push({
        id: 'SCcdTErbws',
        name: 'experiment_source',
        value: properties.experimentSource,
      })
    : eventPropertiesArray.push({
        id: 'SCcdTErbws',
        name: 'experiment_source',
        value: null,
      });
  eventPropertiesArray.push({
    id: '6pig0A-oI',
    name: 'rocket_company',
    value: properties.rocketCompany,
  });
  eventPropertiesArray.push({
    id: 'RfnDFDnzzI',
    name: 'funnel_experience',
    value: properties.funnelExperience,
  });
  properties.qlsCode !== undefined && properties.qlsCode !== null
    ? eventPropertiesArray.push({
        id: 'XmJ5ugueaI',
        name: 'qls_code',
        value: properties.qlsCode,
      })
    : eventPropertiesArray.push({
        id: 'XmJ5ugueaI',
        name: 'qls_code',
        value: null,
      });
  properties.interestRateFinal !== undefined &&
  properties.interestRateFinal !== null
    ? eventPropertiesArray.push({
        id: 'IqMSuOummL',
        name: 'interest_rate_final',
        value: properties.interestRateFinal,
      })
    : eventPropertiesArray.push({
        id: 'IqMSuOummL',
        name: 'interest_rate_final',
        value: null,
      });
  properties.interestRateSuggested !== undefined &&
  properties.interestRateSuggested !== null
    ? eventPropertiesArray.push({
        id: 'f3IiCToqGK',
        name: 'interest_rate_suggested',
        value: properties.interestRateSuggested,
      })
    : eventPropertiesArray.push({
        id: 'f3IiCToqGK',
        name: 'interest_rate_suggested',
        value: null,
      });
  properties.interestRateRecommended !== undefined &&
  properties.interestRateRecommended !== null
    ? eventPropertiesArray.push({
        id: 'MxU13N8Wi7',
        name: 'interest_rate_recommended',
        value: properties.interestRateRecommended,
      })
    : eventPropertiesArray.push({
        id: 'MxU13N8Wi7',
        name: 'interest_rate_recommended',
        value: null,
      });
  properties.amplitudeSessionReplayId !== undefined &&
  properties.amplitudeSessionReplayId !== null
    ? eventPropertiesArray.push({
        id: 'SE7qzwsZG4FfJxDr5aA_f',
        name: 'amplitude_session_replay_id',
        value: properties.amplitudeSessionReplayId,
      })
    : eventPropertiesArray.push({
        id: 'SE7qzwsZG4FfJxDr5aA_f',
        name: 'amplitude_session_replay_id',
        value: null,
      });
  properties.experimentId !== undefined && properties.experimentId !== null
    ? eventPropertiesArray.push({
        id: '6MDW7LlnGH',
        name: 'experiment_id',
        value: properties.experimentId,
      })
    : eventPropertiesArray.push({
        id: '6MDW7LlnGH',
        name: 'experiment_id',
        value: null,
      });
  eventPropertiesArray.push({
    id: 'YekhRhN_M1',
    name: 'page_name',
    value: properties.pageName,
  });
  properties.leadTypeCode !== undefined && properties.leadTypeCode !== null
    ? eventPropertiesArray.push({
        id: 'X34zATaWxvwS-TBvSHZfR',
        name: 'lead_type_code',
        value: properties.leadTypeCode,
      })
    : eventPropertiesArray.push({
        id: 'X34zATaWxvwS-TBvSHZfR',
        name: 'lead_type_code',
        value: null,
      });
  eventPropertiesArray.push({
    id: 'PbS4IP_ap1',
    name: 'app_version',
    value: sysAppVersion,
  });
  eventPropertiesArray.push({
    id: 'DNqrhbpgSj',
    name: 'device_type',
    value: sysDeviceType,
  });
  eventPropertiesArray.push({
    id: 'Ra5Oyin4Tv',
    name: 'os_version',
    value: sysOsVersion,
  });
  eventPropertiesArray.push({
    id: 'z9D75o_NW2',
    name: 'browser_version',
    value: sysBrowserVersion,
  });
  eventPropertiesArray.push({
    id: 'HVyMUTwlFin2UALtdI6AQ',
    name: 'system_rocket_account_id',
    value: sysSystemRocketAccountId,
  });
  eventPropertiesArray.push({
    id: '0mP7RIpF5jqiys6y4VlAq',
    name: 'system_rvid',
    value: sysSystemRvid,
  });
  eventPropertiesArray.push({
    id: 'FHbqjQStMeHS7fgYo5DHJ',
    name: 'system_rocket_mortgage_client_id',
    value: sysSystemRocketMortgageClientId,
  });
  eventPropertiesArray.push({
    id: 'Kk4mMVrkXLj4XzgzCWpQy',
    name: 'system_client_id',
    value: sysSystemClientId,
  });
  eventPropertiesArray.push({
    id: 'AEbCx35uG52zkAssLX_bs',
    name: 'system_gcid',
    value: sysSystemGcid,
  });
  eventPropertiesArray.push({
    id: 'mnnnJ3KJZDDauAWcFOHFR',
    name: 'system_common_id',
    value: sysSystemCommonId,
  });
  eventPropertiesArray.push({
    id: 'Hhq32LlY0mY4OwATaYwch',
    name: 'system_rock_human_id',
    value: sysSystemRockHumanId,
  });
  eventPropertiesArray.push({
    id: '--SybwLChclxCttnpge_u',
    name: 'system_session_replay_id',
    value: sysSystemSessionReplayId,
  });
  eventPropertiesArray.push({
    id: 'xUDhKmtARrXfsslyfeuAW',
    name: 'system_event_id',
    value: sysSystemEventId,
  });
  eventPropertiesArray.push({
    id: 'BOVxTE7k0qTMBeIVDxdd9',
    name: 'system_cooper_customer_id',
    value: sysSystemCooperCustomerId,
  });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  properties.userRvid !== undefined && properties.userRvid !== null
    ? userPropertiesArray.push({
        id: 'FpdlmFaXvi',
        name: 'user_rvid',
        value: properties.userRvid,
      })
    : userPropertiesArray.push({
        id: 'FpdlmFaXvi',
        name: 'user_rvid',
        value: null,
      });
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'VzcK2p-7gj',
        'b8db7260364675866b11ffd15956be815f0d000211b1fd780c709a375b0f0c37',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'loaded_page',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'VzcK2p-7gj',
        'loaded_page',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  // @ts-ignore
  let eventPropertiesSegment: any = { ...eventProperties };
  eventPropertiesSegment['[Amplitude] Session Replay ID'] =
    eventPropertiesSegment['amplitude_session_replay_id'];
  delete eventPropertiesSegment['amplitude_session_replay_id'];
  // @ts-ignore
  let userPropertiesSegment: any = { ...userProperties };
  if (!__AVO_NOOP__) {
    // destination Segment
    Segment.setUserProperties(
      properties.userId_,
      (Object as any).assign({}, userPropertiesSegment),
    );
    if (Segment.logPage) {
      Segment.logPage(
        properties.customDestinationPageName_,
        (Object as any).assign({}, eventPropertiesSegment),
      );
    } else {
      InternalAvoLogger.error(
        'Page method is not implemented in the destination',
        '',
      );
    }
  } else {
    // do nothing
  }
}

export interface LoadedPageClearSignProperties {
  userId_: string;
  customDestinationPageName_: string;
  experimentSource: string | null | undefined;
  rocketCompany: RocketCompanyValueType;
  funnelExperience: FunnelExperienceValueType;
  qlsCode: string | null | undefined;
  interestRateFinal: number | null | undefined;
  interestRateSuggested: number | null | undefined;
  interestRateRecommended: number | null | undefined;
  amplitudeSessionReplayId: string | null | undefined;
  experimentId: string | null | undefined;
  pageName: string;
  userRvid: string | null | undefined;
  leadTypeCode: string | null | undefined;
}
/**
 * loaded_page: Trigger this event when a page loads, event variant
 *
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.experimentSource: This describes where in the product experience the experiment lives. For example, launchpad, rma, etc.
 * @param properties.rocketCompany: Set this to the Rocket company a user is interacting with through a digital or non-digital experience.
 * @param properties.funnelExperience: This is the workflow or experience a user is in within the Rocket ecosystem. Examples: launchpad, rma, etc.
 * @param properties.qlsCode: QLS is rocket's UTM equivalent, QLS code is a unique ID , which links to the entire campaign metadata set at Rocket, containing details down to the image and copy version used in the ad responsible for the traffic
 * @param properties.interestRateFinal: Set this to the closest two-point decimal value for the final interest rate a user receives when their loan closes. This interest rate should not be sent until the loan closes as that is when we know the actual final loan interest rate.
 * @param properties.interestRateSuggested: Set this to the closest two-point decimal value for the suggested interest rate a user sees in a digital top-of-funnel experience OR hears as a current interest rate from a banker on a call. This is the interest rate that initial calculations are based off of, but one that is not based on any unique known facts about the user such as credit score. It is also not a locked interest rate or a final loan interest rate.
 * @param properties.interestRateRecommended: Set this to the closest two-point decimal value for the recommended interest rate a user sees in a digital top-of-funnel experience OR hears as a current interest rate from a banker on a call AFTER providing enough personal information that we can give customized rate information factoring in their credit score. This interest rate is more specific to the user than anything in our very top-of-funnel experiences, but it is not not a locked interest rate or a final loan interest rate.
 * @param properties.amplitudeSessionReplayId: Amplitude Session Replay ID, used within Session Replay Implementation. Mapped to '[Amplitude] Session Replay ID' downstream in Segment.
 * @param properties.experimentId: The combination of experiment ID and variant/control-ID of the experiment that the user experienced.
 * @param properties.pageName: The name of the page where a particular action or event took place
 * @param properties.userRvid: Set this to the first party Rocket cookie ID.
 * @param properties.leadTypeCode: Set to the alphanumeric lead type code value. The lead type code identifies the type of the lead based on specific characteristics of the lead.
 *
 * @see {@link https://www.avo.app/schemas/pUcuftd8KVtPST9UVaqE/branches/nKh1-E0tYjqQaktaFGDvs/events/VzcK2p-7gj.gVJWcCNnX34rUp-l7zlhv}
 */
export function loadedPageClearSign(properties: LoadedPageClearSignProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.experimentSource !== undefined &&
  properties.experimentSource !== null
    ? eventPropertiesArray.push({
        id: 'SCcdTErbws',
        name: 'experiment_source',
        value: properties.experimentSource,
      })
    : eventPropertiesArray.push({
        id: 'SCcdTErbws',
        name: 'experiment_source',
        value: null,
      });
  eventPropertiesArray.push({
    id: '6pig0A-oI',
    name: 'rocket_company',
    value: properties.rocketCompany,
  });
  eventPropertiesArray.push({
    id: 'RfnDFDnzzI',
    name: 'funnel_experience',
    value: properties.funnelExperience,
  });
  properties.qlsCode !== undefined && properties.qlsCode !== null
    ? eventPropertiesArray.push({
        id: 'XmJ5ugueaI',
        name: 'qls_code',
        value: properties.qlsCode,
      })
    : eventPropertiesArray.push({
        id: 'XmJ5ugueaI',
        name: 'qls_code',
        value: null,
      });
  properties.interestRateFinal !== undefined &&
  properties.interestRateFinal !== null
    ? eventPropertiesArray.push({
        id: 'IqMSuOummL',
        name: 'interest_rate_final',
        value: properties.interestRateFinal,
      })
    : eventPropertiesArray.push({
        id: 'IqMSuOummL',
        name: 'interest_rate_final',
        value: null,
      });
  properties.interestRateSuggested !== undefined &&
  properties.interestRateSuggested !== null
    ? eventPropertiesArray.push({
        id: 'f3IiCToqGK',
        name: 'interest_rate_suggested',
        value: properties.interestRateSuggested,
      })
    : eventPropertiesArray.push({
        id: 'f3IiCToqGK',
        name: 'interest_rate_suggested',
        value: null,
      });
  properties.interestRateRecommended !== undefined &&
  properties.interestRateRecommended !== null
    ? eventPropertiesArray.push({
        id: 'MxU13N8Wi7',
        name: 'interest_rate_recommended',
        value: properties.interestRateRecommended,
      })
    : eventPropertiesArray.push({
        id: 'MxU13N8Wi7',
        name: 'interest_rate_recommended',
        value: null,
      });
  properties.amplitudeSessionReplayId !== undefined &&
  properties.amplitudeSessionReplayId !== null
    ? eventPropertiesArray.push({
        id: 'SE7qzwsZG4FfJxDr5aA_f',
        name: 'amplitude_session_replay_id',
        value: properties.amplitudeSessionReplayId,
      })
    : eventPropertiesArray.push({
        id: 'SE7qzwsZG4FfJxDr5aA_f',
        name: 'amplitude_session_replay_id',
        value: null,
      });
  properties.experimentId !== undefined && properties.experimentId !== null
    ? eventPropertiesArray.push({
        id: '6MDW7LlnGH',
        name: 'experiment_id',
        value: properties.experimentId,
      })
    : eventPropertiesArray.push({
        id: '6MDW7LlnGH',
        name: 'experiment_id',
        value: null,
      });
  eventPropertiesArray.push({
    id: 'YekhRhN_M1',
    name: 'page_name',
    value: properties.pageName,
  });
  properties.leadTypeCode !== undefined && properties.leadTypeCode !== null
    ? eventPropertiesArray.push({
        id: 'X34zATaWxvwS-TBvSHZfR',
        name: 'lead_type_code',
        value: properties.leadTypeCode,
      })
    : eventPropertiesArray.push({
        id: 'X34zATaWxvwS-TBvSHZfR',
        name: 'lead_type_code',
        value: null,
      });
  eventPropertiesArray.push({
    id: 'PbS4IP_ap1',
    name: 'app_version',
    value: sysAppVersion,
  });
  eventPropertiesArray.push({
    id: 'DNqrhbpgSj',
    name: 'device_type',
    value: sysDeviceType,
  });
  eventPropertiesArray.push({
    id: 'Ra5Oyin4Tv',
    name: 'os_version',
    value: sysOsVersion,
  });
  eventPropertiesArray.push({
    id: 'z9D75o_NW2',
    name: 'browser_version',
    value: sysBrowserVersion,
  });
  eventPropertiesArray.push({
    id: 'HVyMUTwlFin2UALtdI6AQ',
    name: 'system_rocket_account_id',
    value: sysSystemRocketAccountId,
  });
  eventPropertiesArray.push({
    id: '0mP7RIpF5jqiys6y4VlAq',
    name: 'system_rvid',
    value: sysSystemRvid,
  });
  eventPropertiesArray.push({
    id: 'FHbqjQStMeHS7fgYo5DHJ',
    name: 'system_rocket_mortgage_client_id',
    value: sysSystemRocketMortgageClientId,
  });
  eventPropertiesArray.push({
    id: 'Kk4mMVrkXLj4XzgzCWpQy',
    name: 'system_client_id',
    value: sysSystemClientId,
  });
  eventPropertiesArray.push({
    id: 'AEbCx35uG52zkAssLX_bs',
    name: 'system_gcid',
    value: sysSystemGcid,
  });
  eventPropertiesArray.push({
    id: 'mnnnJ3KJZDDauAWcFOHFR',
    name: 'system_common_id',
    value: sysSystemCommonId,
  });
  eventPropertiesArray.push({
    id: 'Hhq32LlY0mY4OwATaYwch',
    name: 'system_rock_human_id',
    value: sysSystemRockHumanId,
  });
  eventPropertiesArray.push({
    id: '--SybwLChclxCttnpge_u',
    name: 'system_session_replay_id',
    value: sysSystemSessionReplayId,
  });
  eventPropertiesArray.push({
    id: 'xUDhKmtARrXfsslyfeuAW',
    name: 'system_event_id',
    value: sysSystemEventId,
  });
  eventPropertiesArray.push({
    id: 'BOVxTE7k0qTMBeIVDxdd9',
    name: 'system_cooper_customer_id',
    value: sysSystemCooperCustomerId,
  });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  properties.userRvid !== undefined && properties.userRvid !== null
    ? userPropertiesArray.push({
        id: 'FpdlmFaXvi',
        name: 'user_rvid',
        value: properties.userRvid,
      })
    : userPropertiesArray.push({
        id: 'FpdlmFaXvi',
        name: 'user_rvid',
        value: null,
      });
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'VzcK2p-7gj.gVJWcCNnX34rUp-l7zlhv',
        'fc7603993f3f3c640780886de1abad4f300c8f0a916a8c9a004ca3612d4857f6',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'loaded_page',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'VzcK2p-7gj.gVJWcCNnX34rUp-l7zlhv',
        'loaded_page',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  // @ts-ignore
  let eventPropertiesSegment: any = { ...eventProperties };
  eventPropertiesSegment['[Amplitude] Session Replay ID'] =
    eventPropertiesSegment['amplitude_session_replay_id'];
  delete eventPropertiesSegment['amplitude_session_replay_id'];
  // @ts-ignore
  let userPropertiesSegment: any = { ...userProperties };
  if (!__AVO_NOOP__) {
    // destination Segment
    Segment.setUserProperties(
      properties.userId_,
      (Object as any).assign({}, userPropertiesSegment),
    );
    if (Segment.logPage) {
      Segment.logPage(
        properties.customDestinationPageName_,
        (Object as any).assign({}, eventPropertiesSegment),
      );
    } else {
      InternalAvoLogger.error(
        'Page method is not implemented in the destination',
        '',
      );
    }
  } else {
    // do nothing
  }
}

export interface ClickedLinkProperties {
  userId_: string;
  linkName: string;
  linkValue: string;
  learningCenterRelatedArticlePosition:
    | LearningCenterRelatedArticlePositionValueType
    | null
    | undefined;
  time: string;
  linkType: LinkTypeValueType | null | undefined;
  interestRateType: InterestRateTypeValueType | null | undefined;
  linkId: string;
  userRvid: string;
  pageName: string | null | undefined;
}
/**
 * clicked_link: This event fires when a user clicks on a hyperlink within the experience.
 *
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.linkName: This is the display name of the hyperlink that was clicked by the user in the experience
 * @param properties.linkValue: this is the URL associated with the click of a hyperlink on an experience.
 * @param properties.learningCenterRelatedArticlePosition: Set this to the location of the related article clicked (left, center, right)
 * @param properties.time: Set this to the timestamp of when a user (or Rocket team member) completes the action associated with each event.
 * Amplitude compares dates as strings, using the ISO 8601 format: YYYY-MM-DDTHH:mm:ss
 * @param properties.linkType: During a clicked link event, set this to the type of link being clicked.
 * @param properties.interestRateType: Specify the type of rate lock indicated. Options include: float (float_rate) or lock (lock_rate).
 * @param properties.linkId: The unique identifier assigned to the link that was clicked within an experience or application.
 * @param properties.userRvid: Set this to the first party Rocket cookie ID.
 * @param properties.pageName: The name of the page where a particular action or event took place
 *
 * @see {@link https://www.avo.app/schemas/pUcuftd8KVtPST9UVaqE/branches/nKh1-E0tYjqQaktaFGDvs/events/lj8L21_FO0}
 */
export function clickedLink(properties: ClickedLinkProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: '5zOLwSu2Z0',
    name: 'link_name',
    value: properties.linkName,
  });
  eventPropertiesArray.push({
    id: 'brH4i7QVwE',
    name: 'link_value',
    value: properties.linkValue,
  });
  properties.learningCenterRelatedArticlePosition !== undefined &&
  properties.learningCenterRelatedArticlePosition !== null
    ? eventPropertiesArray.push({
        id: '3fIA4WRl52',
        name: 'learning_center_related_article_position',
        value: properties.learningCenterRelatedArticlePosition,
      })
    : eventPropertiesArray.push({
        id: '3fIA4WRl52',
        name: 'learning_center_related_article_position',
        value: null,
      });
  eventPropertiesArray.push({
    id: 'O2iTlkPbDS',
    name: 'time',
    value: properties.time,
  });
  properties.linkType !== undefined && properties.linkType !== null
    ? eventPropertiesArray.push({
        id: 'z8LMxBidEH',
        name: 'link_type',
        value: properties.linkType,
      })
    : eventPropertiesArray.push({
        id: 'z8LMxBidEH',
        name: 'link_type',
        value: null,
      });
  properties.interestRateType !== undefined &&
  properties.interestRateType !== null
    ? eventPropertiesArray.push({
        id: 'OLYw5mxPUl',
        name: 'interest_rate_type',
        value: properties.interestRateType,
      })
    : eventPropertiesArray.push({
        id: 'OLYw5mxPUl',
        name: 'interest_rate_type',
        value: null,
      });
  eventPropertiesArray.push({
    id: 'GUo9YY0_t_',
    name: 'link_id',
    value: properties.linkId,
  });
  properties.pageName !== undefined && properties.pageName !== null
    ? eventPropertiesArray.push({
        id: 'YekhRhN_M1',
        name: 'page_name',
        value: properties.pageName,
      })
    : eventPropertiesArray.push({
        id: 'YekhRhN_M1',
        name: 'page_name',
        value: null,
      });
  eventPropertiesArray.push({
    id: 'PbS4IP_ap1',
    name: 'app_version',
    value: sysAppVersion,
  });
  eventPropertiesArray.push({
    id: 'DNqrhbpgSj',
    name: 'device_type',
    value: sysDeviceType,
  });
  eventPropertiesArray.push({
    id: 'Ra5Oyin4Tv',
    name: 'os_version',
    value: sysOsVersion,
  });
  eventPropertiesArray.push({
    id: 'z9D75o_NW2',
    name: 'browser_version',
    value: sysBrowserVersion,
  });
  eventPropertiesArray.push({
    id: 'HVyMUTwlFin2UALtdI6AQ',
    name: 'system_rocket_account_id',
    value: sysSystemRocketAccountId,
  });
  eventPropertiesArray.push({
    id: '0mP7RIpF5jqiys6y4VlAq',
    name: 'system_rvid',
    value: sysSystemRvid,
  });
  eventPropertiesArray.push({
    id: 'FHbqjQStMeHS7fgYo5DHJ',
    name: 'system_rocket_mortgage_client_id',
    value: sysSystemRocketMortgageClientId,
  });
  eventPropertiesArray.push({
    id: 'Kk4mMVrkXLj4XzgzCWpQy',
    name: 'system_client_id',
    value: sysSystemClientId,
  });
  eventPropertiesArray.push({
    id: 'AEbCx35uG52zkAssLX_bs',
    name: 'system_gcid',
    value: sysSystemGcid,
  });
  eventPropertiesArray.push({
    id: 'mnnnJ3KJZDDauAWcFOHFR',
    name: 'system_common_id',
    value: sysSystemCommonId,
  });
  eventPropertiesArray.push({
    id: 'Hhq32LlY0mY4OwATaYwch',
    name: 'system_rock_human_id',
    value: sysSystemRockHumanId,
  });
  eventPropertiesArray.push({
    id: '--SybwLChclxCttnpge_u',
    name: 'system_session_replay_id',
    value: sysSystemSessionReplayId,
  });
  eventPropertiesArray.push({
    id: 'xUDhKmtARrXfsslyfeuAW',
    name: 'system_event_id',
    value: sysSystemEventId,
  });
  eventPropertiesArray.push({
    id: 'BOVxTE7k0qTMBeIVDxdd9',
    name: 'system_cooper_customer_id',
    value: sysSystemCooperCustomerId,
  });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  userPropertiesArray.push({
    id: 'FpdlmFaXvi',
    name: 'user_rvid',
    value: properties.userRvid,
  });
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'lj8L21_FO0',
        '16fbabe62e1ee374396e9ab17f96205aba75658cd80abb6a1c667c90d566111a',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'clicked_link',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'lj8L21_FO0',
        'clicked_link',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'clicked_link',
        eventProperties,
        'lj8L21_FO0',
        '16fbabe62e1ee374396e9ab17f96205aba75658cd80abb6a1c667c90d566111a',
      );
    }
    // destination Segment
    Segment.setUserProperties(
      properties.userId_,
      (Object as any).assign({}, userProperties),
    );
    Segment.logEvent(
      'clicked_link',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface ClickedLinkClearSignProperties {
  userId_: string;
  linkName: string;
  linkValue: string;
  learningCenterRelatedArticlePosition:
    | LearningCenterRelatedArticlePositionValueType
    | null
    | undefined;
  time: string;
  linkType: LinkTypeValueType | null | undefined;
  interestRateType: InterestRateTypeValueType | null | undefined;
  linkId: string;
  userRvid: string;
  pageName: string | null | undefined;
}
/**
 * clicked_link: This event fires when a user clicks on a hyperlink within the experience., event variant
 *
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.linkName: This is the display name of the hyperlink that was clicked by the user in the experience
 * @param properties.linkValue: this is the URL associated with the click of a hyperlink on an experience.
 * @param properties.learningCenterRelatedArticlePosition: Set this to the location of the related article clicked (left, center, right)
 * @param properties.time: Set this to the timestamp of when a user (or Rocket team member) completes the action associated with each event.
 * Amplitude compares dates as strings, using the ISO 8601 format: YYYY-MM-DDTHH:mm:ss
 * @param properties.linkType: During a clicked link event, set this to the type of link being clicked.
 * @param properties.interestRateType: Specify the type of rate lock indicated. Options include: float (float_rate) or lock (lock_rate).
 * @param properties.linkId: The unique identifier assigned to the link that was clicked within an experience or application.
 * @param properties.userRvid: Set this to the first party Rocket cookie ID.
 * @param properties.pageName: The name of the page where a particular action or event took place
 *
 * @see {@link https://www.avo.app/schemas/pUcuftd8KVtPST9UVaqE/branches/nKh1-E0tYjqQaktaFGDvs/events/lj8L21_FO0.yHHCYJU1XQ06cxIvQAcDs}
 */
export function clickedLinkClearSign(
  properties: ClickedLinkClearSignProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: '5zOLwSu2Z0',
    name: 'link_name',
    value: properties.linkName,
  });
  eventPropertiesArray.push({
    id: 'brH4i7QVwE',
    name: 'link_value',
    value: properties.linkValue,
  });
  properties.learningCenterRelatedArticlePosition !== undefined &&
  properties.learningCenterRelatedArticlePosition !== null
    ? eventPropertiesArray.push({
        id: '3fIA4WRl52',
        name: 'learning_center_related_article_position',
        value: properties.learningCenterRelatedArticlePosition,
      })
    : eventPropertiesArray.push({
        id: '3fIA4WRl52',
        name: 'learning_center_related_article_position',
        value: null,
      });
  eventPropertiesArray.push({
    id: 'O2iTlkPbDS',
    name: 'time',
    value: properties.time,
  });
  properties.linkType !== undefined && properties.linkType !== null
    ? eventPropertiesArray.push({
        id: 'z8LMxBidEH',
        name: 'link_type',
        value: properties.linkType,
      })
    : eventPropertiesArray.push({
        id: 'z8LMxBidEH',
        name: 'link_type',
        value: null,
      });
  properties.interestRateType !== undefined &&
  properties.interestRateType !== null
    ? eventPropertiesArray.push({
        id: 'OLYw5mxPUl',
        name: 'interest_rate_type',
        value: properties.interestRateType,
      })
    : eventPropertiesArray.push({
        id: 'OLYw5mxPUl',
        name: 'interest_rate_type',
        value: null,
      });
  eventPropertiesArray.push({
    id: 'GUo9YY0_t_',
    name: 'link_id',
    value: properties.linkId,
  });
  properties.pageName !== undefined && properties.pageName !== null
    ? eventPropertiesArray.push({
        id: 'YekhRhN_M1',
        name: 'page_name',
        value: properties.pageName,
      })
    : eventPropertiesArray.push({
        id: 'YekhRhN_M1',
        name: 'page_name',
        value: null,
      });
  eventPropertiesArray.push({
    id: 'PbS4IP_ap1',
    name: 'app_version',
    value: sysAppVersion,
  });
  eventPropertiesArray.push({
    id: 'DNqrhbpgSj',
    name: 'device_type',
    value: sysDeviceType,
  });
  eventPropertiesArray.push({
    id: 'Ra5Oyin4Tv',
    name: 'os_version',
    value: sysOsVersion,
  });
  eventPropertiesArray.push({
    id: 'z9D75o_NW2',
    name: 'browser_version',
    value: sysBrowserVersion,
  });
  eventPropertiesArray.push({
    id: 'HVyMUTwlFin2UALtdI6AQ',
    name: 'system_rocket_account_id',
    value: sysSystemRocketAccountId,
  });
  eventPropertiesArray.push({
    id: '0mP7RIpF5jqiys6y4VlAq',
    name: 'system_rvid',
    value: sysSystemRvid,
  });
  eventPropertiesArray.push({
    id: 'FHbqjQStMeHS7fgYo5DHJ',
    name: 'system_rocket_mortgage_client_id',
    value: sysSystemRocketMortgageClientId,
  });
  eventPropertiesArray.push({
    id: 'Kk4mMVrkXLj4XzgzCWpQy',
    name: 'system_client_id',
    value: sysSystemClientId,
  });
  eventPropertiesArray.push({
    id: 'AEbCx35uG52zkAssLX_bs',
    name: 'system_gcid',
    value: sysSystemGcid,
  });
  eventPropertiesArray.push({
    id: 'mnnnJ3KJZDDauAWcFOHFR',
    name: 'system_common_id',
    value: sysSystemCommonId,
  });
  eventPropertiesArray.push({
    id: 'Hhq32LlY0mY4OwATaYwch',
    name: 'system_rock_human_id',
    value: sysSystemRockHumanId,
  });
  eventPropertiesArray.push({
    id: '--SybwLChclxCttnpge_u',
    name: 'system_session_replay_id',
    value: sysSystemSessionReplayId,
  });
  eventPropertiesArray.push({
    id: 'xUDhKmtARrXfsslyfeuAW',
    name: 'system_event_id',
    value: sysSystemEventId,
  });
  eventPropertiesArray.push({
    id: 'BOVxTE7k0qTMBeIVDxdd9',
    name: 'system_cooper_customer_id',
    value: sysSystemCooperCustomerId,
  });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  userPropertiesArray.push({
    id: 'FpdlmFaXvi',
    name: 'user_rvid',
    value: properties.userRvid,
  });
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'lj8L21_FO0.yHHCYJU1XQ06cxIvQAcDs',
        'e286459bf0f17db8ff2c443ded7f74efccd76c0a6d77e1844c7e39b2bd56aaad',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'clicked_link',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'lj8L21_FO0.yHHCYJU1XQ06cxIvQAcDs',
        'clicked_link',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'clicked_link',
        eventProperties,
        'lj8L21_FO0.yHHCYJU1XQ06cxIvQAcDs',
        'e286459bf0f17db8ff2c443ded7f74efccd76c0a6d77e1844c7e39b2bd56aaad',
      );
    }
    // destination Segment
    Segment.setUserProperties(
      properties.userId_,
      (Object as any).assign({}, userProperties),
    );
    Segment.logEvent(
      'clicked_link',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * initialized_session_replay: This event will be fired by the application when the application chooses to initialize session replay.
 *
 * @see {@link https://www.avo.app/schemas/pUcuftd8KVtPST9UVaqE/branches/nKh1-E0tYjqQaktaFGDvs/events/BA74ZPcgoMX9a3e2WFpXc}
 */
export function initializedSessionReplay() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'PbS4IP_ap1',
    name: 'app_version',
    value: sysAppVersion,
  });
  eventPropertiesArray.push({
    id: 'DNqrhbpgSj',
    name: 'device_type',
    value: sysDeviceType,
  });
  eventPropertiesArray.push({
    id: 'Ra5Oyin4Tv',
    name: 'os_version',
    value: sysOsVersion,
  });
  eventPropertiesArray.push({
    id: 'z9D75o_NW2',
    name: 'browser_version',
    value: sysBrowserVersion,
  });
  eventPropertiesArray.push({
    id: 'HVyMUTwlFin2UALtdI6AQ',
    name: 'system_rocket_account_id',
    value: sysSystemRocketAccountId,
  });
  eventPropertiesArray.push({
    id: '0mP7RIpF5jqiys6y4VlAq',
    name: 'system_rvid',
    value: sysSystemRvid,
  });
  eventPropertiesArray.push({
    id: 'FHbqjQStMeHS7fgYo5DHJ',
    name: 'system_rocket_mortgage_client_id',
    value: sysSystemRocketMortgageClientId,
  });
  eventPropertiesArray.push({
    id: 'Kk4mMVrkXLj4XzgzCWpQy',
    name: 'system_client_id',
    value: sysSystemClientId,
  });
  eventPropertiesArray.push({
    id: 'AEbCx35uG52zkAssLX_bs',
    name: 'system_gcid',
    value: sysSystemGcid,
  });
  eventPropertiesArray.push({
    id: 'mnnnJ3KJZDDauAWcFOHFR',
    name: 'system_common_id',
    value: sysSystemCommonId,
  });
  eventPropertiesArray.push({
    id: 'Hhq32LlY0mY4OwATaYwch',
    name: 'system_rock_human_id',
    value: sysSystemRockHumanId,
  });
  eventPropertiesArray.push({
    id: '--SybwLChclxCttnpge_u',
    name: 'system_session_replay_id',
    value: sysSystemSessionReplayId,
  });
  eventPropertiesArray.push({
    id: 'xUDhKmtARrXfsslyfeuAW',
    name: 'system_event_id',
    value: sysSystemEventId,
  });
  eventPropertiesArray.push({
    id: 'BOVxTE7k0qTMBeIVDxdd9',
    name: 'system_cooper_customer_id',
    value: sysSystemCooperCustomerId,
  });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'BA74ZPcgoMX9a3e2WFpXc',
        'd164f3183e2e66ebe88415e3a3b13bca8a2ae84dc5c391ac7db4eb7872fd3690',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'initialized_session_replay',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'BA74ZPcgoMX9a3e2WFpXc',
        'initialized_session_replay',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'initialized_session_replay',
        eventProperties,
        'BA74ZPcgoMX9a3e2WFpXc',
        'd164f3183e2e66ebe88415e3a3b13bca8a2ae84dc5c391ac7db4eb7872fd3690',
      );
    }
    // destination Segment
    Segment.logEvent(
      'initialized_session_replay',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * reinitialized_session_replay: This event will be fired by the application when the application chooses to re-initialize session replay after shutting it down in their user experience.
 *
 * @see {@link https://www.avo.app/schemas/pUcuftd8KVtPST9UVaqE/branches/nKh1-E0tYjqQaktaFGDvs/events/JXVVY19Lc90MXK-DE1Sob}
 */
export function reinitializedSessionReplay() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'PbS4IP_ap1',
    name: 'app_version',
    value: sysAppVersion,
  });
  eventPropertiesArray.push({
    id: 'DNqrhbpgSj',
    name: 'device_type',
    value: sysDeviceType,
  });
  eventPropertiesArray.push({
    id: 'Ra5Oyin4Tv',
    name: 'os_version',
    value: sysOsVersion,
  });
  eventPropertiesArray.push({
    id: 'z9D75o_NW2',
    name: 'browser_version',
    value: sysBrowserVersion,
  });
  eventPropertiesArray.push({
    id: 'HVyMUTwlFin2UALtdI6AQ',
    name: 'system_rocket_account_id',
    value: sysSystemRocketAccountId,
  });
  eventPropertiesArray.push({
    id: '0mP7RIpF5jqiys6y4VlAq',
    name: 'system_rvid',
    value: sysSystemRvid,
  });
  eventPropertiesArray.push({
    id: 'FHbqjQStMeHS7fgYo5DHJ',
    name: 'system_rocket_mortgage_client_id',
    value: sysSystemRocketMortgageClientId,
  });
  eventPropertiesArray.push({
    id: 'Kk4mMVrkXLj4XzgzCWpQy',
    name: 'system_client_id',
    value: sysSystemClientId,
  });
  eventPropertiesArray.push({
    id: 'AEbCx35uG52zkAssLX_bs',
    name: 'system_gcid',
    value: sysSystemGcid,
  });
  eventPropertiesArray.push({
    id: 'mnnnJ3KJZDDauAWcFOHFR',
    name: 'system_common_id',
    value: sysSystemCommonId,
  });
  eventPropertiesArray.push({
    id: 'Hhq32LlY0mY4OwATaYwch',
    name: 'system_rock_human_id',
    value: sysSystemRockHumanId,
  });
  eventPropertiesArray.push({
    id: '--SybwLChclxCttnpge_u',
    name: 'system_session_replay_id',
    value: sysSystemSessionReplayId,
  });
  eventPropertiesArray.push({
    id: 'xUDhKmtARrXfsslyfeuAW',
    name: 'system_event_id',
    value: sysSystemEventId,
  });
  eventPropertiesArray.push({
    id: 'BOVxTE7k0qTMBeIVDxdd9',
    name: 'system_cooper_customer_id',
    value: sysSystemCooperCustomerId,
  });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'JXVVY19Lc90MXK-DE1Sob',
        'd4a94fd01f0ad7b90be9bf2e4aa6b39100566d540e1c13c5997c510df112e699',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'reinitialized_session_replay',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'JXVVY19Lc90MXK-DE1Sob',
        'reinitialized_session_replay',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'reinitialized_session_replay',
        eventProperties,
        'JXVVY19Lc90MXK-DE1Sob',
        'd4a94fd01f0ad7b90be9bf2e4aa6b39100566d540e1c13c5997c510df112e699',
      );
    }
    // destination Segment
    Segment.logEvent(
      'reinitialized_session_replay',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  LearningCenterRelatedArticlePosition,
  RocketCompany,
  InterestRateType,
  FunnelExperience,
  ButtonType,
  LinkType,
  clickedButton,
  clickedButtonClearSign,
  loadedPage,
  loadedPageClearSign,
  clickedLink,
  clickedLinkClearSign,
  initializedSessionReplay,
  reinitializedSessionReplay,
};

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["clickedButton","clickedButtonClearSign","loadedPage","loadedPageClearSign","clickedLink","clickedLinkClearSign","initializedSessionReplay","reinitializedSessionReplay"]
